import React, { Component } from 'react';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import { GoCheck } from 'react-icons/go';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';

class Accounting extends Component {
    static displayName = Accounting.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            StopListFlag: false,
            permissionFlag: true
        }
        this.testPermission();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: this.props.reduxData.userInfo,
            loading: false,
            username: this.props.reduxData.userInfo.username,
        });
        this.setState({
            level: this.props.ourLevel
        });
        var dept = this.props.reduxData.userInfo.level.pk
        dept = dept.substring(0, (dept.indexOf('-') - 1));
        //if (dept != "Applications" && dept != "Accounting") {
        //    this.setState({
        //        permissionFlag: "false"
        //    })
        //}
        //this.recordComingHere();
        this.testPermission();
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1025",
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1025"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    componentDidMount() {

    }

    async processStopList() {
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('StopList', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            StopListFlag: data
        });
        setTimeout(() => {
            this.setState({
                StopListlag: false
            })
        }, 5000)
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        //if (this.props.justSwitch == true) {
        //    this.props.passNewPage(1);
        //}
        //else {
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            <h3>Process New Stoplist: </h3><Button onClick={this.processStopList.bind(this)}>Execute</Button>&nbsp;<div style={{ visibility: this.state.StopListFlag == true ? 'visible' : 'hidden' }}> Processing, email incoming <GoCheck style={{ visibility: this.state.StopListFlag == true ? 'visible' : 'hidden' }} /></div><p />
                            Make sure there is a CSV file named "DataFile.csv" located in " \\altair\d$\StopListProcessing " before pressing this button<p />
                            {/*<button onClick{() => navigator.clipboard.writeText('\\altair\d$\StopListProcessing')}>Copy Path</button>*/}
                        </div>
                    )}
                </UserContext.Consumer>
            );
        //}
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(Accounting);